(function(){
  function init(){
  const DATA_URL = "https://cdn.shopify.com/s/files/1/0643/1365/5353/files/bm-colors-nohex.json?v=1755868630";
  const MAX_RENDER = 60;
  let COLORS = [];
  let open = false, hi = -1;
  const $input = document.getElementById('bm-color-input');
  const $list  = document.getElementById('bm-results');
  const $wrap  = document.getElementById('bm-picked');
  const $chip  = document.getElementById('bm-chip');
  const $label = document.getElementById('bm-label');
  const $hidden= document.getElementById('bm-hidden');
  if(!$input || !$hidden) return;
  if($input.dataset.bmInit==='1') return;
  $input.dataset.bmInit='1';
  const norm = s => (s||"").toString().trim().toLowerCase();

  // --- helper hint: tells shoppers where to pick/change their custom color ---
  const HINT_DEFAULT = '<span style="font-size:16px;line-height:1;">&#8595;</span> <span>Pick your custom color here — type any Benjamin Moore name or code</span>';
  const HINT_SET = '<span style="color:#0a8a3f;font-size:15px;line-height:1;">&#10003;</span> <span>Your color is set — type here anytime to change it</span>';
  var $hint = document.createElement('div');
  $hint.id = 'bm-hint';
  $hint.style.cssText = 'display:flex;align-items:center;gap:7px;font-size:13.5px;font-weight:700;color:#C8202E;margin:0 0 8px;';
  $hint.innerHTML = HINT_DEFAULT;
  var pickerBox = document.getElementById('bm-color-picker');
  if(pickerBox){ pickerBox.insertBefore($hint, pickerBox.firstChild); }
  else if($input.parentNode){ $input.parentNode.insertBefore($hint, $input); }

  function itemsFor(q){
    if(!q) return [];
    q = norm(q);
    const starts=[], contains=[];
    for(const c of COLORS){
      const code = norm(c.code), name = norm(c.name);
      if(code.startsWith(q) || name.startsWith(q)) starts.push(c);
      else if(code.includes(q) || name.includes(q)) contains.push(c);
      if(starts.length + contains.length >= MAX_RENDER) break;
    }
    return starts.concat(contains).slice(0, MAX_RENDER);
  }
  function render(arr){
    $list.innerHTML = '';
    if(!arr.length){ $list.style.display='none'; open=false; return; }
    arr.forEach((c,i)=>{
      const li = document.createElement('li');
      li.style.padding='8px 10px'; li.style.cursor='pointer';
      li.style.display='flex'; li.style.alignItems='center'; li.style.gap='10px';
      li.setAttribute('data-idx', i);
      const chip = document.createElement('span');
      chip.style.display='inline-block'; chip.style.width='16px'; chip.style.height='16px';
      chip.style.border='1px solid #999'; chip.style.borderRadius='4px';
      if(c.swatch){ chip.style.background = `center/cover no-repeat url('${c.swatch}')`; }
      const txt = document.createElement('span');
      txt.textContent = `${c.code || ''}${c.code && c.name ? ' ' : ''}${c.name || ''}`;
      li.appendChild(chip); li.appendChild(txt);
      li.addEventListener('mouseenter', () => highlight(i));
      li.addEventListener('mouseleave', () => highlight(-1));
      li.addEventListener('click', () => choose(c));
      $list.appendChild(li);
    });
    $list.style.display='block'; open=true; highlight(-1);
  }
  function highlight(i){
    [...$list.children].forEach((el,idx)=>{ el.style.background = idx===i ? '#f3f4f6' : '#fff'; });
    hi = i;
  }
  function choose(c){
    const label = `${c.code || ''}${c.code && c.name ? ' ' : ''}${c.name || ''}`.trim();
    $input.value = label;
    $hidden.value = label;
    if($chip && c.swatch){ $chip.style.background = `center/cover no-repeat url('${c.swatch}')`; }
    if($label){ $label.textContent = label; }
    if($wrap){ $wrap.style.display = 'flex'; }
    if($hint){ $hint.innerHTML = HINT_SET; }
    $list.style.display='none'; open=false;
  }
  $input.addEventListener('input', e => render(itemsFor(e.target.value)));
  $input.addEventListener('keydown', e => {
    if(!open) return;
    const max = $list.children.length;
    if(e.key==='ArrowDown'){ e.preventDefault(); highlight(Math.min(max-1, Math.max(0, hi+1))); }
    if(e.key==='ArrowUp'){   e.preventDefault(); highlight(Math.max(0, Math.min(max-1, hi-1))); }
    if(e.key==='Enter'){     e.preventDefault(); if(hi>=0){ $list.children[hi].click(); } }
    if(e.key==='Escape'){    $list.style.display='none'; open=false; }
  });
  document.addEventListener('click', e => { if(!e.target.closest('#bm-color-picker')){ $list.style.display='none'; open=false; } });
  function prefillFromURL(){
    try{
      var p = new URLSearchParams(location.search).get('color');
      if(!p) return;
      var q = norm(p);
      var m = COLORS.find(function(c){ return norm(c.code)===q; })
           || COLORS.find(function(c){ return norm((c.code||'')+' '+(c.name||''))===q; })
           || COLORS.find(function(c){ return norm(c.name)===q; });
      if(m) choose(m);
    }catch(e){}
  }
  fetch(DATA_URL, {cache:'force-cache'}).then(r=>r.json()).then(data=>{ COLORS = Array.isArray(data) ? data : []; prefillFromURL(); }).catch(()=>{});
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
